module.exports = __webpack_public_path__ + "static/media/mouton_04_thumb_hover.558e4d66.png";